/* =============================================
   EL-TALAWY SHOPIFY THEME — theme.js
   ============================================= */

/* ─── CART DRAWER ─── */
const cartDrawer   = document.getElementById('cart-drawer');
const cartOverlay  = document.getElementById('cart-overlay');
const cartClose    = document.getElementById('cart-close');
const cartBody     = document.getElementById('cart-drawer-body');
const cartFooter   = document.getElementById('cart-drawer-footer');
const cartSubtotal = document.getElementById('cart-subtotal');

function openCart()  { cartDrawer?.classList.add('is-open'); cartOverlay?.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
function closeCart() { cartDrawer?.classList.remove('is-open'); cartOverlay?.classList.remove('is-open'); document.body.style.overflow = ''; }

cartClose?.addEventListener('click', closeCart);
cartOverlay?.addEventListener('click', closeCart);

function formatMoney(cents) {
  return (cents / 100).toLocaleString('en-EG', { style: 'currency', currency: 'EGP', minimumFractionDigits: 2 });
}

async function fetchCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function renderCart() {
  const cart = await fetchCart();
  const count = cart.item_count;

  // Update badge counts
  document.querySelectorAll('.js-cart-count').forEach(el => el.textContent = count);

  if (count === 0) {
    cartBody.innerHTML = `
      <div class="cart-drawer__empty">
        <span style="font-size:56px">🛒</span>
        <p>Your cart is empty</p>
        <a href="/collections/all" class="btn btn--outline" style="margin-top:8px">Start Shopping</a>
      </div>`;
    cartFooter.style.display = 'none';
    return;
  }

  cartBody.innerHTML = `<div class="cart-drawer__items">${cart.items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <img class="cart-item__img" src="${item.image}" alt="${item.product_title}" loading="lazy">
      <div class="cart-item__info">
        <div class="cart-item__title">${item.product_title}</div>
        ${item.variant_title !== 'Default Title' ? `<div style="font-size:12px;color:#888;margin-bottom:4px">${item.variant_title}</div>` : ''}
        <div class="cart-item__price">${formatMoney(item.final_line_price)} <span style="font-size:12px;color:#aaa;font-weight:600">× ${item.quantity}</span></div>
        <a class="cart-item__remove" href="#" data-key="${item.key}">Remove</a>
      </div>
    </div>`).join('')}</div>`;

  cartSubtotal.textContent = formatMoney(cart.total_price);
  cartFooter.style.display = 'block';

  cartBody.querySelectorAll('.cart-item__remove').forEach(btn => {
    btn.addEventListener('click', async e => {
      e.preventDefault();
      const key = btn.dataset.key;
      await fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ id: key, quantity: 0 }) });
      renderCart();
    });
  });
}

/* ─── ADD TO CART ─── */
async function addToCart(variantId, quantity = 1, btn = null) {
  if (btn) { btn.disabled = true; btn.innerHTML = '<span class="spinner"></span>'; }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });

    if (!res.ok) throw new Error('Could not add to cart');

    await renderCart();
    openCart();
    showToast('✓ Added to cart!', 'success');
  } catch (err) {
    showToast('⚠ Could not add item', 'error');
  } finally {
    if (btn) { btn.disabled = false; btn.innerHTML = '🛒 Add to Cart'; }
  }
}

// Listen for all add-to-cart buttons
document.addEventListener('click', e => {
  const btn = e.target.closest('[data-add-to-cart]');
  if (!btn) return;
  e.preventDefault();
  const id = btn.dataset.variantId || btn.dataset.addToCart;
  if (id) addToCart(id, 1, btn);
});

// Cart icon opens drawer
document.addEventListener('click', e => {
  if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); renderCart(); openCart(); }
});

/* ─── TOAST ─── */
let toastTimer;
function showToast(msg, type = 'success') {
  let toast = document.getElementById('toast-msg');
  if (!toast) { toast = document.createElement('div'); toast.id = 'toast-msg'; toast.className = 'toast'; document.body.appendChild(toast); }
  toast.textContent = msg;
  toast.className = `toast toast--${type} is-visible`;
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2800);
}

/* ─── QUANTITY SELECTORS ─── */
document.addEventListener('click', e => {
  const btn = e.target.closest('.qty-btn');
  if (!btn) return;
  const input = btn.closest('.qty-selector')?.querySelector('.qty-input');
  if (!input) return;
  const val = parseInt(input.value) || 1;
  if (btn.dataset.dir === 'plus')  input.value = val + 1;
  if (btn.dataset.dir === 'minus') input.value = Math.max(1, val - 1);
});

/* ─── VARIANT SELECTION ─── */
document.addEventListener('click', e => {
  const opt = e.target.closest('.variant-option');
  if (!opt) return;
  const group = opt.closest('.variant-options');
  group?.querySelectorAll('.variant-option').forEach(o => o.classList.remove('active'));
  opt.classList.add('active');

  const form = opt.closest('form');
  if (form) {
    const varId = opt.dataset.variantId;
    const hiddenInput = form.querySelector('input[name="id"]');
    if (hiddenInput && varId) hiddenInput.value = varId;

    // Update price display
    const price     = opt.dataset.price;
    const compare   = opt.dataset.comparePrice;
    const priceEl   = form.querySelector('.product-page__price-current');
    const compareEl = form.querySelector('.product-page__price-compare');
    if (priceEl && price) priceEl.textContent = formatMoney(parseInt(price));
    if (compareEl) { compareEl.textContent = compare ? formatMoney(parseInt(compare)) : ''; compareEl.style.display = compare ? '' : 'none'; }
  }
});

/* ─── PRODUCT GALLERY ─── */
document.addEventListener('click', e => {
  const thumb = e.target.closest('.product-thumb');
  if (!thumb) return;
  const gallery = thumb.closest('.product-page__gallery');
  const main    = gallery?.querySelector('.product-page__gallery-main img');
  if (main && thumb.dataset.src) {
    main.src = thumb.dataset.src;
    gallery.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  }
});

/* ─── MOBILE MENU ─── */
document.querySelector('[data-mobile-menu]')?.addEventListener('click', () => {
  document.getElementById('mobile-nav')?.classList.add('is-open');
  document.body.style.overflow = 'hidden';
});
document.querySelector('[data-mobile-menu-close]')?.addEventListener('click', () => {
  document.getElementById('mobile-nav')?.classList.remove('is-open');
  document.body.style.overflow = '';
});

/* ─── INIT ─── */
renderCart();
